
	"use strict";
	var $ = jQuery;
	import "./swap-plugin.js";

	function initSwap() {
		$(".js-swap").swap();
	}

	$(initSwap);
